import { getBrowserDeviceInfo, getQueryParams } from "./common";
import { reportEvent } from "./logUtils";
import { DEVICE_ID } from "@adgm/libs";

export const downloadGAReport = (moduleName: string) => {
  const deviceId = localStorage.getItem(DEVICE_ID) ?? "";
  const params = getQueryParams();
  const deviceInfo = getBrowserDeviceInfo();
  reportEvent({
    moduleName,
    // @ts-ignore
    detailParams: {
      ...params,
      ...deviceInfo,
      deviceId,
    },
  });
};
